/** @jsx jsx */
import PropTypes from "prop-types"
import { Children } from "react"
import { jsx, Styled } from "theme-ui"

export default function Subtitle({ children, textAlign }) {
  const align = textAlign ? textAlign : "center"
  const extraMargin = textAlign === "left" ? "20px" : "0px"

  if (Children.count(children)) {
    return (
      <Styled.p
        sx={{
          textAlign: align,
          marginBottom: extraMargin,
          fontSize: [3, 4, 4],
          color: "black",
          textAlign: ["center", "center", "left"],
        }}
      >
        {children}
      </Styled.p>
    )
  }
  return null
}

Subtitle.defaultProps = {
  children: null,
}

Subtitle.propTypes = {
  children: PropTypes.node,
}
